<template>
  <div
    class="py-4 container-fluid min-vh-100"
    :class="$store.state.isDarkMode ? 'strategy-page-dark' : 'bg-light-moniex'"
    :style="$store.state.isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="strategy-hero-banner mb-3"
      :style="$store.state.isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="strategy-hero-content">
        <h1
          :style="$store.state.isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Strategie</h1>
        <p :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">Základní přístupy, které ti pomůžou hrát s klidem — od úročení kapitálu až po long a short.</p>
      </div>
    </div>

    <div v-if="StrategyData && StrategyData.length">

      <div class="row mb-4">
        <div class="col-12">
          <div
            class="border-0 shadow-sm rounded-4 overflow-hidden p-4 moniex-strategy-card"
            :style="surfaceStyle"
          >
            <div class="d-flex align-items-start">
              <div
                class="avatar-circle me-3 fw-bold"
                :class="`bg-${StrategyData[0].StrategyColor || 'warning'}-soft text-${StrategyData[0].StrategyColor || 'warning'}`"
              >
                UK
              </div>
              <div class="w-100">
                <div class="d-flex justify-content-between align-items-center mb-1 flex-wrap">
                  <h5
                    class="mb-0 fw-bold fs-5"
                    :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                  >
                    {{ StrategyData[0].StrategyTitle }}
                  </h5>
                  <span
                    v-if="StrategyData[0].StrategyBadge"
                    class="badge-moniex"
                    :class="`bg-${StrategyData[0].StrategyColor || 'warning'}-soft text-${StrategyData[0].StrategyColor || 'warning'}`"
                  >
                    {{ StrategyData[0].StrategyBadge }}
                  </span>
                </div>
                <div
                  class="fs-6 mt-3 v-html-content line-height-lg"
                  :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important;' : ''"
                  v-html="StrategyData[0].StrategyText"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row align-items-start">
        <div class="col-12 col-lg-8">
          <div
            v-for="(strategy, index) in StrategyData.slice(1)"
            :key="index"
            class="border-0 shadow-sm rounded-4 overflow-hidden mb-4 p-4 moniex-strategy-card"
            :style="surfaceStyle"
          >
            <div class="d-flex align-items-start">
              <div
                class="avatar-circle me-3 fw-bold"
                :class="`bg-${strategy.StrategyColor || 'success'}-soft text-${strategy.StrategyColor || 'success'}`"
              >
                {{ strategy.StrategyTitle ? strategy.StrategyTitle.charAt(0) : 'S' }}
              </div>
              <div class="w-100">
                <div class="d-flex justify-content-between align-items-center mb-1 flex-wrap">
                  <h5
                    class="mb-0 fw-bold fs-5"
                    :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                  >
                    {{ strategy.StrategyTitle }}
                  </h5>
                  <span
                    v-if="strategy.StrategyBadge"
                    class="badge-moniex"
                    :class="`bg-${strategy.StrategyColor || 'success'}-soft text-${strategy.StrategyColor || 'success'}`"
                  >
                    {{ strategy.StrategyBadge }}
                  </span>
                </div>
                <div
                  class="fs-6 mt-3 v-html-content line-height-lg"
                  :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important;' : ''"
                  v-html="strategy.StrategyText"
                ></div>

                <div
                  v-if="strategy.StrategyExample"
                  class="mt-4 p-3 rounded-3"
                  :style="$store.state.isDarkMode
                    ? 'background: #1E293B !important; border-left: 4px solid #334155 !important;'
                    : 'background: #f1f3f5 !important; border-left: 4px solid #ced4da !important;'"
                >
                  <div class="d-flex align-items-center mb-2">
                    <span class="fs-6 me-2">💡</span>
                    <strong
                      class="fs-6"
                      :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                    >Modelová situace z praxe:</strong>
                  </div>
                  <span
                    class="small line-height-md v-html-content"
                    :style="$store.state.isDarkMode ? 'color: #94A3B8 !important;' : ''"
                    v-html="strategy.StrategyExample"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4 mt-4 mt-lg-0">
          <div
            class="border-0 shadow-sm rounded-4 text-center position-relative mb-4 img-inga-card"
            :class="$store.state.isDarkMode ? 'p-0' : 'p-3'"
            :style="$store.state.isDarkMode
              ? 'background: #0F172A !important; border: none !important; box-shadow: none !important; border-radius: 0.65rem !important;'
              : 'background: #ffffff !important; border: none !important; border-radius: 0.65rem !important;'"
          >
            <div
              class="inga-speech-bubble"
              :class="{ 'inga-speech-bubble-dark': $store.state.isDarkMode }"
            >
              „Chceš vydělat, i když jde ČEZ ke dnu? Od toho je tu SHORT! Neboj se hrát proti proudu, jsou to jen virtuální prachy.“
            </div>
            <IngaPortrait :src="imgRoot + 'inga.jpg'" />
          </div>

          <ActiveGamesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";
import IngaPortrait from "./components/custom/IngaPortrait.vue";

const store = useStore();
const StrategyData = ref([]);
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);

const surfaceStyle = computed(() => {
  if (store.state.isDarkMode) {
    return "background: #0F172A !important; background-color: #0F172A !important; background-image: none !important; border: 1px solid #334155 !important; --bs-card-bg: #0F172A; border-radius: 0.65rem !important;";
  }
  return "background: #ffffff; border: 1px solid transparent; border-radius: 0.65rem !important;";
});

const fetchStrategyData = async () => {
  StrategyData.value = await dataService.GetStrategy();
};

fetchStrategyData();
</script>

<style scoped>
.strategy-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.strategy-hero-content h1 {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}

.strategy-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

.strategy-page-dark .strategy-hero-banner {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}

.bg-light-moniex { background-color: #f8f9fa; }
.moniex-strategy-card {
  border-radius: 0.65rem !important;
  overflow: hidden;
}
.line-height-lg { line-height: 1.6; }
.line-height-md { line-height: 1.4; }

.bg-success-soft { background-color: rgba(40, 167, 69, 0.1) !important; }
.text-success { color: #28a745 !important; }
.bg-danger-soft { background-color: rgba(220, 53, 69, 0.1) !important; }
.text-danger { color: #dc3545 !important; }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.1) !important; }
.text-warning { color: #ffc107 !important; }
.bg-orange-soft { background-color: rgba(255, 138, 72, 0.12) !important; }
.text-orange { color: #FF8A48 !important; }
.bg-primary-soft { background-color: rgba(13, 110, 253, 0.1) !important; }
.text-primary { color: #0d6efd !important; }
.bg-info-soft { background-color: rgba(13, 202, 240, 0.1) !important; }
.text-info { color: #0dcaf0 !important; }
.bg-dark-soft { background-color: rgba(33, 37, 41, 0.1) !important; }

.avatar-circle {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 1.1rem !important;
  flex-shrink: 0 !important;
}

.badge-moniex {
  padding: 4px 14px !important;
  border-radius: 20px !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.img-inga-card { margin-top: 3.5rem !important; border: none !important; border-radius: 0.65rem !important; }

.inga-speech-bubble {
  position: absolute !important;
  top: -65px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background-color: #ffffff !important;
  border: 2px solid #FF7A00 !important;
  color: #1E293B !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  padding: 10px 14px !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06) !important;
  z-index: 10 !important;
  width: 92% !important;
  max-width: 280px !important;
}
.inga-speech-bubble-dark {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}
.inga-speech-bubble::after, .inga-speech-bubble::before {
  content: ''; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); border-style: solid; display: block; width: 0;
}
.inga-speech-bubble::after { border-width: 10px 10px 0; border-color: #ffffff transparent transparent; z-index: 11; }
.inga-speech-bubble::before { bottom: -13px; border-width: 11px 11px 0; border-color: #FF7A00 transparent transparent; z-index: 9; }
.inga-speech-bubble-dark::after { border-color: #1E293B transparent transparent; }

.v-html-content :deep(div),
.v-html-content :deep(p),
.v-html-content :deep(span),
.v-html-content :deep(li) {
  background: transparent !important;
  background-color: transparent !important;
  color: inherit !important;
}
</style>
